import {
  getFromStorage,
  removeFromStorage,
  setToStorage,
} from "@/utils/localStorageUtils";

/**
 * Two-stage abandoned-checkout marker for the r-1913 promo.
 *
 * "Started" is written on checkout pages (see useCheckoutStartedEvent), but a
 * user standing on the checkout page has not abandoned anything yet — reading
 * "started" from inside the checkout flow would offer the promo to every
 * first-time checkout visitor. So "started" is only promoted to
 * "abandoned" when a dashboard page outside the checkout flow renders with the
 * marker set (see AbandonedCheckoutPromoBanner): that render is the "abandoned
 * checkout and later returned to the dashboard" moment. A completed purchase
 * clears both stages (see PostPaymentSuccess).
 */
const CHECKOUT_STARTED_KEY = "abandonedCheckout:started";
const CHECKOUT_ABANDONED_KEY = "abandonedCheckout:abandoned";

export const markCheckoutStarted = () => {
  setToStorage(CHECKOUT_STARTED_KEY, "true");
};

export const markCheckoutAbandonedIfStarted = () => {
  if (getFromStorage(CHECKOUT_STARTED_KEY)) {
    setToStorage(CHECKOUT_ABANDONED_KEY, "true");
  }
};

export const clearCheckoutProgress = () => {
  removeFromStorage(CHECKOUT_STARTED_KEY);
  removeFromStorage(CHECKOUT_ABANDONED_KEY);
};

export const hasAbandonedCheckout = () =>
  Boolean(getFromStorage(CHECKOUT_ABANDONED_KEY));
